if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();
      this.init();
    }

    init() {
      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      console.groupEnd();
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      console.group('ProductForm Submit Handler');
      console.log('Submit event:', {
        formId: this.form.id,
        variantId: this.form.querySelector('[name=id]').value,
        buttonDisabled: this.submitButton.getAttribute('aria-disabled') === 'true'
      });

      if (this.submitButton.getAttribute('aria-disabled') === 'true') {
        console.warn('Submit blocked - button disabled');
        console.groupEnd();
        return;
      }

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      const formDataObj = {};
      formData.forEach((value, key) => formDataObj[key] = value);
      console.log('Form data being sent:', formDataObj);

      if (this.cart) {
        const sections = this.cart.getSectionsToRender().map((section) => section.id);
        formData.append('sections', sections);
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
        console.log('Cart sections requested:', sections);
      }
      config.body = formData;

      console.log('Sending fetch request to:', `${routes.cart_add_url}`);
      fetch(`${routes.cart_add_url}`, config)
        .then((response) => {
          console.log('Response status:', response.status);
          if (!response.ok) {
            console.warn('Response not OK:', {
              status: response.status,
              statusText: response.statusText
            });
          }
          return response.json();
        })
        .then((response) => {
          console.log('Response data:', response);
          if (response.status) {
            console.error('Error in response:', response.description);
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          }

          this.error = false;
          if (this.cart) {
            console.log('Rendering cart drawer with response');
            this.cart.renderContents(response);
          } else {
            console.log('No cart drawer found, redirecting to:', window.routes.cart_url);
            window.location = window.routes.cart_url;
          }
        })
        .catch((e) => {
          console.error('Fetch error:', e);
          console.error(e);
        })
        .finally(() => {
          console.log('Request completed, cleaning up UI');
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
          console.groupEnd();
        });
    }

    handleErrorMessage(errorMessage = false) {
      console.group('Handle Error Message');
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      console.log('Error wrapper found:', !!this.errorMessageWrapper);
      if (!this.errorMessageWrapper) {
        console.log('No error wrapper found, skipping error display');
        console.groupEnd();
        return;
      }
      
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');
      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        console.warn('Displaying error:', errorMessage);
        this.errorMessage.textContent = errorMessage;
      }
      console.groupEnd();
    }
  });
}
